/**
 * @generated SignedSource<<04deeef1f2658d38f33a4fd67e657cf2>>
 * @relayHash e23d2e5c7dfca11e2dc4cccb39b1eb51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f866042051dd312587032db4be12d468485a124b37cb6fa7b64164638a68737

import type { ConcreteRequest } from 'relay-runtime';
export type HelpCenterHubGoLiveHelpCenterInput = {
  helpCenterAri: string;
};
export type migrationReviewActionBarGoLiveHelpCenterMutation$variables = {
  cloudId: string;
  input: HelpCenterHubGoLiveHelpCenterInput;
};
export type migrationReviewActionBarGoLiveHelpCenterMutation$data = {
  readonly helpCenter: {
    readonly goLiveHelpCenter: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null;
      }> | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type migrationReviewActionBarGoLiveHelpCenterMutation = {
  response: migrationReviewActionBarGoLiveHelpCenterMutation$data;
  variables: migrationReviewActionBarGoLiveHelpCenterMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterMutationApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "HelpCenterHubGoLiveHelpCenterPayload",
        "kind": "LinkedField",
        "name": "goLiveHelpCenter",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "migrationReviewActionBarGoLiveHelpCenterMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "migrationReviewActionBarGoLiveHelpCenterMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3f866042051dd312587032db4be12d468485a124b37cb6fa7b64164638a68737",
    "metadata": {},
    "name": "migrationReviewActionBarGoLiveHelpCenterMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "dc20ceea767638a38fd0257323a7c400";

export default node;
